export default {"src":"/_next/static/media/twitch-logo-hover.3bfa80f8.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};